export default __webpack_public_path__ + "static/media/three.96bf6464.glb";